import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9e531da2")

_pushScopeId("data-v-9e531da2")
const _hoisted_1 = { class: "dialog__content" }
const _hoisted_2 = { class: "dialog__list" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-settings" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Gestion du Compte ")
const _hoisted_5 = {
  key: 0,
  class: "dialog__item"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-tool" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Gestion du site")
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-logout" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Déconnexion ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.userMenuVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: false,
            onClose: _ctx.closeDialog,
            onClick: _ctx.closeDialog
          }, {
            body: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teamsICaptain, (team, ix) => {
                    return (_openBlock(), _createBlock("div", {
                      key: ix,
                      class: "dialog__item"
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/teams/${team.name}`
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_TeamLabel, {
                            team: team,
                            captain: true
                          }, null, 8, ["team"])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128)),
                  _createVNode("div", {
                    class: "dialog__item",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPreferencesDialog && _ctx.showPreferencesDialog(...args)))
                  }, [
                    _hoisted_3,
                    _hoisted_4
                  ]),
                  (_ctx.isLoggedIn && _ctx.isAdmin)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode(_component_router_link, { to: "/admin" }, {
                          default: _withId(() => [
                            _hoisted_6,
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    class: "dialog__item",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.requestLogout && _ctx.requestLogout(...args)))
                  }, [
                    _createVNode(_component_router_link, { to: "/logout" }, {
                      default: _withId(() => [
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})